import { Navbar } from "./components/Navbar";
import { About, Footer, Header, Skills } from "./container";
import "./App.scss";
import Testimonial from "./container/Testimonial/Testimonial";
function App() {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Testimonial />
      <Skills />
      <Footer />
    </div>
  );
}

export default App;
